module.exports = [
	'/pages/index/index',//首页
	'/pages/user_right/coupon/coupon_center',//领券中心
	'/pages/web_view/web_view',//web_view
	'/pages/user/growth/growth',//去升级
	'/pages/act/score/score',//积分乐园
	'/pages/act/score/exchange_detail/exchange_detail',//积分兑换商品路径
	'/pages/act/score/my_list/my_list',//积分兑换我的兑换页
]


// WEBPACK FOOTER //
// ./module/portalPathList.js